import React from "react";
import { FaEnvelope, FaInstagram, FaLinkedinIn, FaPhoneAlt, FaWhatsapp } from "react-icons/fa";
import LogoFooter from "../Assets/LogoFooter.png";

function Footer() {
    return (
        <footer id="contact" className="w-full bg-[#002b56] text-white">
            <div className="mx-auto w-full max-w-[1860px] px-5 pb-7 pt-8 sm:px-6 lg:px-14">
                <div className="grid grid-cols-1 gap-8 lg:grid-cols-[1.2fr_1fr] lg:items-center">
                    <div className="space-y-6">
                        <div className="flex flex-row items-center gap-4 sm:gap-5">
                            <img
                                src={LogoFooter}
                                alt="SimpliConnect"
                                className="h-[46px] w-auto object-contain sm:h-[60px]"
                            />
                            <div className="flex items-center gap-3 sm:gap-4">
                                <a
                                    href="https://wa.me/94729472947"
                                    className="inline-flex h-10 w-10 items-center justify-center rounded-full bg-[#25D366] text-[20px] text-white"
                                    aria-label="WhatsApp"
                                >
                                    <FaWhatsapp />
                                </a>
                                <a
                                    href="https://www.instagram.com/simpliconnectlk/?utm_source=ig_web_button_share_sheet"
                                    className="inline-flex h-10 w-10 items-center justify-center rounded-xl bg-[#E4405F] text-[20px] text-white"
                                    aria-label="Instagram"
                                >
                                    <FaInstagram />
                                </a>
                                <a
                                    href="https://www.linkedin.com/company/simpliconnect-lk/"
                                    className="inline-flex h-10 w-10 items-center justify-center rounded-md bg-[#0A66C2] text-[18px] text-white"
                                    aria-label="LinkedIn"
                                >
                                    <FaLinkedinIn />
                                </a>
                            </div>
                        </div>

                        <div className="space-y-3">
                            <div className="flex items-center gap-3 sm:gap-4">
                                <span className="inline-flex h-9 w-9 items-center justify-center rounded-full bg-[#16558F] text-[18px] font-semibold">
                                    <FaEnvelope aria-hidden="true" className="h-4 w-4" />
                                </span>
                                <a
                                    href="mailto:info@simpliconnectlk.com"
                                    className="min-w-0 break-all text-[14px] font-medium text-[#E5EEF8] sm:text-[18px]"
                                >
                                    info@simpliconnectlk.com
                                </a>
                            </div>
                            <div className="flex items-center gap-3 sm:gap-4">
                                <span className="inline-flex h-9 w-9 items-center justify-center rounded-full bg-[#16558F] text-[15px] font-semibold">
                                    <FaPhoneAlt aria-hidden="true" className="h-4 w-4" />
                                </span>
                                <a
                                    href="tel:+94729472947"
                                    className="text-[14px] font-medium text-[#E5EEF8] sm:text-[18px]"
                                >
                                    (+94) 72 947 2947
                                </a>
                            </div>
                        </div>
                    </div>

                    <div className="text-left lg:text-right">
                        <p className="whitespace-nowrap text-[32px] font-black leading-[0.95] tracking-tight text-[#305274] sm:text-[56px] lg:text-[76px]">
                            LET'S WORK TOGETHER
                        </p>
                    </div>
                </div>
            </div>

            <div className="w-full bg-[#305274]">
                <div className="mx-auto w-full max-w-[1860px] px-6 py-2 text-center text-[13px] text-[#D7E6F5] sm:text-[14px] lg:px-14">
                    Simpliconnectlk.com &copy; 2025. All Rights Reserved
                </div>
            </div>
        </footer>
    );
}

export default Footer;
